"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import styles from "./Header.module.css";

import { getHeaderColor } from "@/utils/utilsFunc";
import { usePreloaderAnimation } from "@/context/HomePreloaderAnimationContext";
import { useShowNav } from "@/context/HeaderShowNav";

import Logo from "@/common/Logo/Logo";
import HeaderNav from "./HeaderNav/HeaderNav";
import HeaderBurgerMenu from "./HeaderBurgerMenu/HeaderBurgerMenu";

function HeaderLayout({ children }) {
  const pathname = usePathname();
  const [isLight, setIsLight] = useState(() => getHeaderColor(pathname));

  const { showNav, setShowNav } = useShowNav();
  // const { showPreloader } = usePreloaderAnimation();

  useEffect(() => {
    if (
      pathname === "/news" &&
      window.matchMedia("(max-width: 700px)").matches
    ) {
      setIsLight(true);
    } else {
      const color = getHeaderColor(pathname);
      setIsLight(color);
    }
  }, [pathname]);

  useEffect(() => {
    showNav && setShowNav(false);
  }, [pathname]);

  return (
    <>
      {showNav && <div className={styles.layoutFix} />}

      <div
        className={`${isLight ? styles.light : ""} ${styles.headerContainer} ${
          showNav ? styles.isActive : ""
        }`}
        style={{
          "--header-color": isLight
            ? "var(--color-grey-100"
            : "var(--color-primary-dark)",
        }}
      >
        <Link href="/" className={styles.headerLogo}>
          <Logo isLight={isLight} />
        </Link>
        {/* {showPreloader ? (
          <button
            className={styles.headerLogo}
            onClick={() => {
              router.push("/");
              setShowNav(false);
            }}
          >
            <Logo />
          </button>
        ) : (
          <HeaderLogoAnimation>
            <button
              className={styles.headerLogo}
              onClick={() => {
                router.push("/");
                setShowNav(false);
              }}
            >
              <Logo isLight={isLight} />
            </button>
          </HeaderLogoAnimation>
        )} */}
        <HeaderNav isLight={isLight}>{children}</HeaderNav>
        <HeaderBurgerMenu />
      </div>
    </>
  );
}

export default HeaderLayout;
